$(function(){
  $.each($('.slick-ul'), function(k, v){
    //Get the parameters
    var autoplay = true;
    var autoplay_speed = 3000;
    var infinite = true;
    var dots = true;
    var slides_to_show = 1;
    var arrows = true;
    
    data_attrs = $(this).data();
    console.log(data_attrs);
    if(data_attrs['autoplay'] != true){
     	autoplay = false;
    }
    
    if(data_attrs['autoplay_speed'] != 3000){
     	autoplay_speed = parseInt(data_attrs['autoplay_speed']);
    }
    
    if(data_attrs['infinite'] != true){
     	infinite = false;
    }
    
    if(data_attrs['dots'] != true){
     	dots = false;
    }
    
    if(data_attrs['slides_to_show'] != "1"){
     	slides_to_show = parseInt(data_attrs['slides_to_show']);
    }
    
    if(data_attrs['arrows'] != true){
    	arrows = false; 
    }
    
    $(this).slick({
      autoplay: autoplay,
      autoplaySpeed: autoplay_speed,
      infinite: infinite,
      dots: dots,
      slidesToShow: slides_to_show,
      arrows: arrows
    });
  });
});